import { eThongKeCanXuLyActionsObj } from "../../action-types/dashboard/IThongKeCanXuLyActionTypes";
import { generateActions } from "../generateActions";

export const thongKeCanXuLyActions = {
  ...generateActions(eThongKeCanXuLyActionsObj, "THONG_KE_CAN_XU_LY"),
};
